// @flow

import type { Action } from './store.type';

export const GET_MERCHANDISING_REQUEST = 'GET_MERCHANDISING_REQUEST';
type GET_MERCHANDISING_REQUEST_TYPE = 'GET_MERCHANDISING_REQUEST';

export const GET_MERCHANDISING_SUCCESS = 'GET_MERCHANDISING_SUCCESS';
type GET_MERCHANDISING_SUCCESS_TYPE = 'GET_MERCHANDISING_SUCCESS';

export const GET_MERCHANDISING_FAILURE = 'GET_MERCHANDISING_FAILURE';
type GET_MERCHANDISING_FAILURE_TYPE = 'GET_MERCHANDISING_FAILURE';

type MerchandisingType = {
  id: string,
  name: string,
  collections: Array<Object>,
  ranking: string,
  rules: Array<Object>,
  order: number,
  status: boolean
};

type MerchandisingSuccess = {
  merchandising: MerchandisingType,
  actionName: string,
  waitSyncAt: number,
  scheduleSyncIn: number,
  scheduleSyncAfter: number
};

type MerchandisingFailure = {
  error: any
};

type MerchandisingRulesSuccess = {
  data: {
    skip: number,
    limit: number,
    data: Array<MerchandisingType>,
    total: number,
    waitSyncAt: number,
    scheduleSyncIn: number,
    scheduleSyncAfter: number
  }
};

type GetMerchandisingRequestAction = Action<GET_MERCHANDISING_REQUEST_TYPE, null>;

type GetMerchandisingSuccessAction = Action<
  GET_MERCHANDISING_SUCCESS_TYPE,
  MerchandisingRulesSuccess
>;

type GetMerchandisingFailureAction = Action<GET_MERCHANDISING_FAILURE_TYPE, MerchandisingFailure>;

// Create Merchandising Rule
export const CREATE_MERCHANDISING_REQUEST = 'CREATE_MERCHANDISING_REQUEST';
type CREATE_MERCHANDISING_REQUEST_TYPE = 'CREATE_MERCHANDISING_REQUEST';

export const CREATE_MERCHANDISING_SUCCESS = 'CREATE_MERCHANDISING_SUCCESS';
type CREATE_MERCHANDISING_SUCCESS_TYPE = 'CREATE_MERCHANDISING_SUCCESS';

export const CREATE_MERCHANDISING_FAILURE = 'CREATE_MERCHANDISING_FAILURE';
type CREATE_MERCHANDISING_FAILURE_TYPE = 'CREATE_MERCHANDISING_FAILURE';

type CreateMerchandisingRequestAction = Action<CREATE_MERCHANDISING_REQUEST_TYPE, null>;

type CreateMerchandisingSuccessAction = Action<
  CREATE_MERCHANDISING_SUCCESS_TYPE,
  MerchandisingSuccess
>;

type CreateMerchandisingFailureAction = Action<
  CREATE_MERCHANDISING_FAILURE_TYPE,
  MerchandisingFailure
>;

// Delete Merchandising Rule
export const DELETE_MERCHANDISING_RULE_REQUEST = 'DELETE_MERCHANDISING_RULE_REQUEST';
type DELETE_MERCHANDISING_RULE_REQUEST_TYPE = 'DELETE_MERCHANDISING_RULE_REQUEST';

export const DELETE_MERCHANDISING_RULE_SUCCESS = 'DELETE_MERCHANDISING_RULE_SUCCESS';
type DELETE_MERCHANDISING_RULE_SUCCESS_TYPE = 'DELETE_MERCHANDISING_RULE_SUCCESS';

export const DELETE_MERCHANDISING_RULE_FAILURE = 'DELETE_MERCHANDISING_RULE_FAILURE';
type DELETE_MERCHANDISING_RULE_FAILURE_TYPE = 'DELETE_MERCHANDISING_RULE_FAILURE';

type DeleteMerchandisingRequestAction = Action<DELETE_MERCHANDISING_RULE_REQUEST_TYPE, null>;

type DeleteMerchandisingSuccessAction = Action<
  DELETE_MERCHANDISING_RULE_SUCCESS_TYPE,
  MerchandisingSuccess
>;

type DeleteMerchandisingFailureAction = Action<
  DELETE_MERCHANDISING_RULE_FAILURE_TYPE,
  MerchandisingFailure
>;

// Update Merchandising Rule
export const UPDATE_MERCHANDISING_RULE_REQUEST = 'UPDATE_MERCHANDISING_RULE_REQUEST';
type UPDATE_MERCHANDISING_RULE_REQUEST_TYPE = 'UPDATE_MERCHANDISING_RULE_REQUEST';

export const UPDATE_MERCHANDISING_RULE_SUCCESS = 'UPDATE_MERCHANDISING_RULE_SUCCESS';
type UPDATE_MERCHANDISING_RULE_SUCCESS_TYPE = 'UPDATE_MERCHANDISING_RULE_SUCCESS';

export const UPDATE_MERCHANDISING_RULE_FAILURE = 'UPDATE_MERCHANDISING_RULE_FAILURE';
type UPDATE_MERCHANDISING_RULE_FAILURE_TYPE = 'UPDATE_MERCHANDISING_RULE_FAILURE';

type UpdateMerchandisingRequestAction = Action<UPDATE_MERCHANDISING_RULE_REQUEST_TYPE, null>;

type UpdateMerchandisingSuccessAction = Action<
  UPDATE_MERCHANDISING_RULE_SUCCESS_TYPE,
  MerchandisingSuccess
>;

type UpdateMerchandisingFailureAction = Action<
  UPDATE_MERCHANDISING_RULE_FAILURE_TYPE,
  MerchandisingFailure
>;

// Update Merchandising Rule
export const REORDER_MERCHANDISING_RULES_REQUEST = 'REORDER_MERCHANDISING_RULES_REQUEST';
type REORDER_MERCHANDISING_RULES_REQUEST_TYPE = 'REORDER_MERCHANDISING_RULES_REQUEST';

export const REORDER_MERCHANDISING_RULES_SUCCESS = 'REORDER_MERCHANDISING_RULES_SUCCESS';
type REORDER_MERCHANDISING_RULES_SUCCESS_TYPE = 'REORDER_MERCHANDISING_RULES_SUCCESS';

export const REORDER_MERCHANDISING_RULES_FAILURE = 'REORDER_MERCHANDISING_RULES_FAILURE';
type REORDER_MERCHANDISING_RULES_FAILURE_TYPE = 'REORDER_MERCHANDISING_RULES_FAILURE';

type ReorderMerchandisingRulesRequestAction = Action<
  REORDER_MERCHANDISING_RULES_REQUEST_TYPE,
  null
>;

type ReorderMerchandisingRulesSuccessAction = Action<
  REORDER_MERCHANDISING_RULES_SUCCESS_TYPE,
  MerchandisingSuccess
>;

type ReorderMerchandisingRulesFailureAction = Action<
  REORDER_MERCHANDISING_RULES_FAILURE_TYPE,
  MerchandisingFailure
>;

// Merchandising Rule Names
export const GET_MERCHANDISING_RULE_NAMES_REQUEST = 'GET_MERCHANDISING_RULE_NAMES_REQUEST';
type GET_MERCHANDISING_RULE_NAMES_REQUEST_TYPE = 'GET_MERCHANDISING_RULE_NAMES_REQUEST';

export const GET_MERCHANDISING_RULE_NAMES_SUCCESS = 'GET_MERCHANDISING_RULE_NAMES_SUCCESS';
type GET_MERCHANDISING_RULE_NAMES_SUCCESS_TYPE = 'GET_MERCHANDISING_RULE_NAMES_SUCCESS';

export const GET_MERCHANDISING_RULE_NAMES_FAILURE = 'GET_MERCHANDISING_RULE_NAMES_FAILURE';
type GET_MERCHANDISING_RULE_NAMES_FAILURE_TYPE = 'GET_MERCHANDISING_RULE_NAMES_FAILURE';

type GetMerchandisingRuleNamesRequestAction = Action<
  GET_MERCHANDISING_RULE_NAMES_REQUEST_TYPE,
  null
>;

type GetMerchandisingRuleNamesSuccessAction = Action<
  GET_MERCHANDISING_RULE_NAMES_SUCCESS_TYPE,
  { data: Object }
>;

type GetMerchandisingRuleNamesFailureAction = Action<
  GET_MERCHANDISING_RULE_NAMES_FAILURE_TYPE,
  MerchandisingFailure
>;

type RuleName = {
  id: string,
  name: string
};

// Merchandising Rule Names
export const GET_MERCHANDISING_RULE_REQUEST = 'GET_MERCHANDISING_RULE_REQUEST';
type GET_MERCHANDISING_RULE_REQUEST_TYPE = 'GET_MERCHANDISING_RULE_REQUEST';

export const GET_MERCHANDISING_RULE_SUCCESS = 'GET_MERCHANDISING_RULE_SUCCESS';
type GET_MERCHANDISING_RULE_SUCCESS_TYPE = 'GET_MERCHANDISING_RULE_SUCCESS';

export const GET_MERCHANDISING_RULE_FAILURE = 'GET_MERCHANDISING_RULE_FAILURE';
type GET_MERCHANDISING_RULE_FAILURE_TYPE = 'GET_MERCHANDISING_RULE_FAILURE';

type GetMerchandisingRuleRequestAction = Action<GET_MERCHANDISING_RULE_REQUEST_TYPE, null>;

type GetMerchandisingRuleSuccessAction = Action<
  GET_MERCHANDISING_RULE_SUCCESS_TYPE,
  { data: MerchandisingType }
>;

type GetMerchandisingRuleFailureAction = Action<
  GET_MERCHANDISING_RULE_FAILURE_TYPE,
  MerchandisingFailure
>;

/* #region: Show feedback version */
export const SHOW_FEEDBACK_VERSION = 'SHOW_FEEDBACK_VERSION';
type SHOW_FEEDBACK_VERSION_TYPE = 'SHOW_FEEDBACK_VERSION';
type ShowFeedbackVersion = Action<SHOW_FEEDBACK_VERSION_TYPE, {}>;
/* #endregion */

/* #region: Hide feedback version */
export const HIDE_FEEDBACK_VERSION = 'HIDE_FEEDBACK_VERSION';
type HIDE_FEEDBACK_VERSION_TYPE = 'HIDE_FEEDBACK_VERSION';
type HideFeedbackVersion = Action<HIDE_FEEDBACK_VERSION_TYPE, {}>;
/* #endregion */

/* #region: Send feedback version */
export const SEND_FEEDBACK_MERCHANDISING_VERSION_REQUEST =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_REQUEST';
type SEND_FEEDBACK_MERCHANDISING_VERSION_REQUEST_TYPE =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_REQUEST';

export const SEND_FEEDBACK_MERCHANDISING_VERSION_SUCCESS =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_SUCCESS';
type SEND_FEEDBACK_MERCHANDISING_VERSION_SUCCESS_TYPE =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_SUCCESS';

export const SEND_FEEDBACK_MERCHANDISING_VERSION_FAILURE =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_FAILURE';
type SEND_FEEDBACK_MERCHANDISING_VERSION_FAILURE_TYPE =
  'SEND_FEEDBACK_MERCHANDISING_VERSION_FAILURE';

type SendFeedbackSwitchVersionRequestAction = Action<
  SEND_FEEDBACK_MERCHANDISING_VERSION_REQUEST_TYPE,
  null
>;

type SendFeedbackSwitchVersionSuccessAction = Action<
  SEND_FEEDBACK_MERCHANDISING_VERSION_SUCCESS_TYPE,
  { data: Object }
>;

type SendFeedbackSwitchVersionFailureAction = Action<
  SEND_FEEDBACK_MERCHANDISING_VERSION_FAILURE_TYPE,
  MerchandisingFailure
>;
/* #endregion */

// Action and State
export type MerchandisingAction =
  | GetMerchandisingRequestAction
  | GetMerchandisingSuccessAction
  | GetMerchandisingFailureAction
  | CreateMerchandisingRequestAction
  | CreateMerchandisingSuccessAction
  | CreateMerchandisingFailureAction
  | DeleteMerchandisingRequestAction
  | DeleteMerchandisingSuccessAction
  | DeleteMerchandisingFailureAction
  | UpdateMerchandisingRequestAction
  | UpdateMerchandisingSuccessAction
  | UpdateMerchandisingFailureAction
  | ReorderMerchandisingRulesRequestAction
  | ReorderMerchandisingRulesSuccessAction
  | ReorderMerchandisingRulesFailureAction
  | GetMerchandisingRuleNamesRequestAction
  | GetMerchandisingRuleNamesSuccessAction
  | GetMerchandisingRuleNamesFailureAction
  | GetMerchandisingRuleRequestAction
  | GetMerchandisingRuleSuccessAction
  | GetMerchandisingRuleFailureAction
  | ShowFeedbackVersion
  | HideFeedbackVersion
  | SendFeedbackSwitchVersionRequestAction
  | SendFeedbackSwitchVersionSuccessAction
  | SendFeedbackSwitchVersionFailureAction;

export type MerchandisingState = {
  loading: boolean,
  saving: boolean,
  deleting: boolean,
  reordering: boolean,
  feedbackLoading: boolean,
  success: boolean,
  error: null,
  merchandisings: Array<MerchandisingType>,
  merchandising: MerchandisingType | {},
  total: number,
  ruleNames: Array<RuleName>,
  feedbackVersion: boolean
};
